/* ════════════════════════════════════════════════════════════════
   ISODASH MINI-CART  (v10.6.46-dev)
   ────────────────────────────────────────────────────────────────
   Slide-in-Sidebar rechts mit dem aktuellen Shopify-Warenkorb.
   – Fetch via Shopify Ajax Cart API (/cart.js, /cart/change.js)
   – Read-only Mengen (Flaschenzahl folgt dem berechneten Bohrplan)
   – "Zeile entfernen" via POST /cart/change.js { line, quantity:0 }
   – Dev-Fallback (localhost): synthetisiert einen Demo-Cart aus
     IsoDash.Calculations.getFinalAnalysis(), damit UI lokal testbar
     bleibt. Im Demo-Mode wirken Remove-Aktionen nur auf den Panel-
     State, nicht auf Shopify.

   Public API:
     window.IsoDashMiniCart.open()
     window.IsoDashMiniCart.close()
     window.IsoDashMiniCart.refresh()
   ════════════════════════════════════════════════════════════════ */
(function (w) {
  'use strict';

  var PANEL_ID = 'isodash-mini-cart';
  var CSS_ID   = 'isodash-mini-cart-css';
  var ISOFIN_VARIANT = '55049427616117';

  var _panel    = null;
  var _open     = false;
  var _cartData = null;
  var _busy     = false;

  /* ── v229.6: TTL-Safety-Check (Mirror von sticky-warenkorb.js) ──
     Greift falls Sticky-Bar nicht geladen ist (z.B. /pages/kalkulator).
     Sticky-Bar ist Hauptverantwortlicher; hier nur Belt-and-Suspenders. */
  var __MC_ISOWIZ_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var __MC_ISOWIZ_BORN_KEY = '__ISOWIZ_ANALYSIS_BORN__';
  function _mcCheckTTLAndPurge() {
    try {
      var raw = localStorage.getItem(__MC_ISOWIZ_BORN_KEY);
      if (!raw) return false;
      var ts = parseInt(String(raw).split('::')[0], 10);
      if (!isFinite(ts) || ts <= 0) return false;
      if (Date.now() - ts > __MC_ISOWIZ_TTL_MS) {
        var keys = [
          '__ISOWIZ__::analysis', '__ISOWIZ__::calcState',
          '__ISOWIZ_TEST__::analysis', '__ISOWIZ_TEST__::calcState',
          'isofinAnalysis', 'isofinCalcState',
          '__ISOWIZ_RESUME_ANALYSIS__', '__ISOWIZ_RESUME_STEP4_ONCE__',
          '__ISOWIZ_RESUME_STEP__', '__ISOWIZ_RETURN_TO_STEP4__',
          'isowiz_step4_completedSignature', '__ISOWIZ_STICKY_PANEL_ANALYSIS__',
          __MC_ISOWIZ_BORN_KEY
        ];
        for (var i = 0; i < keys.length; i++) {
          try { localStorage.removeItem(keys[i]); } catch (_) {}
          try { sessionStorage.removeItem(keys[i]); } catch (_) {}
        }
        return true;
      }
      return false;
    } catch (_) { return false; }
  }

  /* ── v229.4: Dynamischer Isofin-Titel aus IsoWiz-Analyse ───── */
  function _fmtNum(n) {
    var v = Number(n || 0);
    if (!isFinite(v) || v <= 0) return '';
    var s = (Math.round(v * 10) / 10).toString();
    return s.replace('.', ',');
  }
  function getIsofinDynamicTitle() {
    /* v229.6: TTL prüfen — wenn abgelaufen, alles wegwerfen → null */
    if (_mcCheckTTLAndPurge()) return null;
    try {
      var calc = (w.IsoWiz && w.IsoWiz.Calculations) || (w.IsoDash && w.IsoDash.Calculations);
      if (!calc || typeof calc.getFinalAnalysis !== 'function') return null;
      var a = calc.getFinalAnalysis();
      if (!a || typeof a !== 'object') return null;
      var label = a.barrierLabel || (a.moistureType === 'side' ? 'Flächensperre' : 'Horizontalsperre');
      var dim = '';
      if (a.moistureType === 'side') {
        var L = _fmtNum(a.surfaceLengthM);
        var H = _fmtNum(a.surfaceHeightM);
        if (L && H) {
          var area = _fmtNum(Number(a.surfaceLengthM) * Number(a.surfaceHeightM));
          dim = L + '×' + H + 'm' + (area ? ' (' + area + 'm²)' : '');
        }
      } else {
        var W = _fmtNum(a.wallLengthM);
        if (W) dim = W + 'm';
      }
      var title = 'Isofin® Sanierungspaket (DIY) für Ihre ' + label + (dim ? ' (' + dim + ')' : '');
      return { title: title };
    } catch (_) { return null; }
  }
  function isIsofinLine(item) {
    if (!item) return false;
    var v = item.variant_id;
    return String(v) === ISOFIN_VARIANT;
  }

  /* ── Utils ────────────────────────────────────────────────── */
  function formatEuro(cents) {
    var v = Number(cents || 0) / 100;
    return v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00A0€';
  }

  function isLocalDev() {
    try {
      var h = location.hostname || '';
      return location.protocol === 'file:' ||
             h === 'localhost' || h === '127.0.0.1' || h.indexOf('.local') !== -1;
    } catch (_) { return false; }
  }

  /* ── Shopify Ajax Cart API ────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        if (cart && cart.items) return cart;
        /* Dev-Fallback */
        if (isLocalDev()) return buildDemoCart();
        return { items: [], total_price: 0, item_count: 0 };
      });
  }

  function postRemove(lineIdx) {
    if (_cartData && _cartData._demo) {
      /* Dev: lokale Mutation */
      var items = (_cartData.items || []).slice();
      items.splice(lineIdx - 1, 1);
      var total = items.reduce(function (s, it) { return s + (it.final_line_price || it.line_price || 0); }, 0);
      var cnt   = items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
      return Promise.resolve({ items: items, total_price: total, item_count: cnt, _demo: true });
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: lineIdx, quantity: 0 })
    }).then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ── Wall-Blurb (personalisierte Zeile über dem Item) ──────
     Liefert z.B. "8 m Horizontalsperre" oder "6,5 m² Flächensperre".
     Liest aus dem Shell-Derivat, das bereits lengthM/isSide/surfaceAreaM2 liefert. */
  function getWallBlurb() {
    try {
      var d = null;
      if (w.IsoDashShell && typeof w.IsoDashShell.tbDerived === 'function') {
        var p = (w.IsoDashShell.moduleStore && typeof w.IsoDashShell.moduleStore.get === 'function')
                ? w.IsoDashShell.moduleStore.get() : {};
        d = w.IsoDashShell.tbDerived(p);
      }
      if (!d || !d.hasAnalysis) return null;
      var isSide = !!d.isSide;
      var label  = isSide ? 'Fl\u00e4chensperre' : 'Horizontalsperre';
      var num, unit;
      if (isSide && d.surfaceAreaM2 && isFinite(d.surfaceAreaM2)) {
        num  = d.surfaceAreaM2;
        unit = 'm\u00B2';
      } else if (d.lengthM && isFinite(d.lengthM)) {
        num  = d.lengthM;
        unit = 'm';
      } else {
        return label;
      }
      var str = (num % 1 === 0)
        ? num.toFixed(0)
        : num.toFixed(1).replace('.', ',');
      return str + '\u00A0' + unit + ' ' + label;
    } catch (_) { return null; }
  }

  function buildDemoCart() {
    try {
      if (w.IsoDash && w.IsoDash.Calculations && typeof w.IsoDash.Calculations.getFinalAnalysis === 'function') {
        var a = w.IsoDash.Calculations.getFinalAnalysis();
        if (a && Number(a.calculatedBottles) > 0) {
          var bottles = Math.max(1, Math.round(a.calculatedBottles));
          var totalC  = Math.round((a.totalPriceIsofin || 0) * 100);
          var unitC   = Math.round(totalC / bottles);
          /* Original-Preis (ohne Staffel) f\u00fcr strike-through */
          var origUnitC = Math.round((w.IsoDash.Calculations.getOriginalPrice
            ? w.IsoDash.Calculations.getOriginalPrice()
            : 19.90) * 100);
          var origTotalC = origUnitC * bottles;
          return {
            items: [{
              key: 'demo-line-1',
              variant_id: ISOFIN_VARIANT,
              product_title: 'Isofin\u00ae Trockene W\u00e4nde',
              title: 'Isofin\u00ae Trockene W\u00e4nde',
              quantity: bottles,
              price: unitC,
              original_line_price: origTotalC,
              line_price: origTotalC,
              final_line_price: totalC,
              image: 'https://cdn.shopify.com/s/files/1/0846/5550/5691/files/sanierungspaket-isofin-500px-1x1.jpg?v=1768280218'
            }],
            total_price: totalC,
            original_total_price: origTotalC,
            item_count: bottles,
            _demo: true
          };
        }
      }
    } catch (_) {}
    return { items: [], total_price: 0, item_count: 0, _demo: true };
  }

  /* \u2500\u2500 Mengenrabatt-Helper \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
     Berechnet pro Item Original-Preis vs. Staffel-Preis und gibt zur\u00fcck,
     ob ein Rabatt aktiv ist. Funktioniert mit Shopify-Cart-Items UND
     mit unserem internen Calculations-Engine. */
  function getItemDiscount(item) {
    var qty = item.quantity || 0;
    var finalPrc = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
    var origPrc  = item.original_line_price != null ? item.original_line_price : item.line_price;
    /* Wenn Shopify keinen original_line_price liefert ODER kein Rabatt erkennbar \u2192
       eigene Staffel-Berechnung als Backup (nur f\u00fcr Isofin-Variant). */
    var calc = w.IsoDash && w.IsoDash.Calculations;
    var isIsofin = String(item.variant_id) === ISOFIN_VARIANT;
    if (calc && typeof calc.getDiscountInfo === 'function' && isIsofin && qty > 0) {
      var info = calc.getDiscountInfo(qty);
      var origCents  = Math.round(info.originalTotal * 100);
      var finalCents = Math.round(info.finalTotal * 100);
      /* Wenn Shopify den Brutto-Preis hat (origPrc \u2248 originalTotal), aber wir
         laut Staffel rabattieren \u2192 finalPrc auf Staffel-Wert korrigieren. */
      if (info.hasDiscount && Math.abs(finalPrc - origCents) < 50) {
        finalPrc = finalCents;
      }
      /* Original-Preis ggf. erg\u00e4nzen, falls Shopify ihn nicht liefert. */
      if (origPrc == null || origPrc < finalPrc) {
        origPrc = origCents;
      }
    }
    if (origPrc == null) origPrc = finalPrc;
    var hasDiscount = origPrc > finalPrc;
    return {
      qty: qty,
      finalPrc: finalPrc,
      origPrc: origPrc,
      saved: hasDiscount ? (origPrc - finalPrc) : 0,
      hasDiscount: hasDiscount
    };
  }

  function getCartTotals(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return { final: 0, original: 0, saved: 0, hasDiscount: false };
    }
    var fSum = 0, oSum = 0;
    cart.items.forEach(function (it) {
      var d = getItemDiscount(it);
      fSum += d.finalPrc;
      oSum += d.origPrc;
    });
    /* Bevorzugt Shopify's gemeldete Werte, wenn verf\u00fcgbar */
    if (cart.total_price != null) fSum = cart.total_price;
    if (cart.original_total_price != null && cart.original_total_price > fSum) {
      oSum = cart.original_total_price;
    }
    return {
      final: fSum,
      original: Math.max(oSum, fSum),
      saved: Math.max(0, oSum - fSum),
      hasDiscount: oSum > fSum
    };
  }

  /* ── CSS ─────────────────────────────────────────────────── */
  function injectCSS() {
    if (document.getElementById(CSS_ID)) return;
    var p = '#' + PANEL_ID;
    var st = document.createElement('style');
    st.id = CSS_ID;
    /* Alle Layout-Props mit !important gegen GemPages/Shopify-Theme-Resets.
       Das Mini-Cart muss themeunabhängig konsistent rendern. */
    var I = ' !important';
    st.textContent = [
      /* ─── Shell ─────────────────────────────────────────── */
      p + '{position:fixed'+I+';inset:0'+I+';z-index:99999'+I+';pointer-events:none'+I+';font-family:inherit'+I+';font-variant-numeric:tabular-nums'+I+'}',
      p + ' *{box-sizing:border-box'+I+'}',
      p + ' .mc-backdrop{position:absolute'+I+';inset:0'+I+';background:radial-gradient(ellipse at top right,rgba(10,10,12,.55) 0%,rgba(10,10,12,.35) 80%)'+I+';opacity:0'+I+';transition:opacity .3s ease'+I+';pointer-events:none'+I+';backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}',
      p + ' .mc-panel{position:absolute'+I+';top:0'+I+';right:0'+I+';bottom:0'+I+';width:440px'+I+';max-width:92vw'+I+';background:var(--ds-surface,#fff)'+I+';color:var(--ds-text,#111)'+I+';box-shadow:-16px 0 48px rgba(0,0,0,.18),-2px 0 8px rgba(0,0,0,.08)'+I+';transform:translateX(105%)'+I+';transition:transform .35s cubic-bezier(.4,0,.2,1)'+I+';display:flex'+I+';flex-direction:column'+I+';pointer-events:auto'+I+';border-left:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';margin:0'+I+'}',
      p + '.mc-open .mc-backdrop{opacity:1'+I+';pointer-events:auto'+I+'}',
      p + '.mc-open .mc-panel{transform:translateX(0)'+I+'}',

      /* ─── Header ────────────────────────────────────────── */
      p + ' .mc-head{display:flex'+I+';align-items:center'+I+';justify-content:space-between'+I+';gap:16px'+I+';padding:22px 24px 18px'+I+';border:none'+I+';border-bottom:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';flex-shrink:0'+I+';background:transparent'+I+';margin:0'+I+'}',
      p + ' .mc-head-title{display:flex'+I+';flex-direction:column'+I+';gap:3px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-head-title h3{margin:0'+I+';padding:0'+I+';font-size:19px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.2'+I+';letter-spacing:-.01em'+I+';border:none'+I+'}',
      p + ' .mc-head-sub{font-size:12px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';line-height:1'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-close{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:36px'+I+';height:36px'+I+';background:transparent'+I+';border:none'+I+';border-radius:10px'+I+';color:var(--ds-text-muted,#666)'+I+';cursor:pointer'+I+';transition:background .18s,color .18s'+I+';flex-shrink:0'+I+';padding:0'+I+';margin:0'+I+';font-family:inherit'+I+'}',
      p + ' .mc-close svg{width:18px'+I+';height:18px'+I+';display:block'+I+'}',
      p + ' .mc-close:hover{background:var(--ds-surface-hover,rgba(0,0,0,.05))'+I+';color:var(--ds-text,#111)'+I+'}',

      /* ─── Body ──────────────────────────────────────────── */
      p + ' .mc-body{flex:1'+I+';overflow-y:auto'+I+';overflow-x:hidden'+I+';padding:20px 20px 12px'+I+';display:flex'+I+';flex-direction:column'+I+';gap:12px'+I+';-webkit-overflow-scrolling:touch;background:transparent'+I+';margin:0'+I+'}',
      p + ' .mc-body::-webkit-scrollbar{width:6px}',
      p + ' .mc-body::-webkit-scrollbar-thumb{background:var(--ds-border,rgba(0,0,0,.12));border-radius:3px}',

      /* ─── Item-Card (enth\u00e4lt Ware + USPs in einer Umrandung) ── */
      p + ' .mc-item{position:relative'+I+';display:flex'+I+';flex-direction:column'+I+';gap:0'+I+';padding:16px'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:14px'+I+';transition:border-color .18s,transform .2s,box-shadow .2s'+I+';margin:0'+I+'}',
      p + ' .mc-item-main{display:grid'+I+';grid-template-columns:84px 1fr'+I+';gap:16px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-item:hover{border-color:var(--ds-border-hover,rgba(0,0,0,.14))'+I+'}',
      p + ' .mc-item.mc-item-leaving{opacity:0'+I+';transform:translateX(20px)'+I+';transition:opacity .25s,transform .25s'+I+'}',
      p + ' .mc-thumb{width:84px'+I+';height:84px'+I+';object-fit:cover'+I+';border-radius:10px'+I+';background:var(--ds-surface,#fff)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.06))'+I+';flex-shrink:0'+I+';display:block'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-info{display:flex'+I+';flex-direction:column'+I+';gap:8px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-name{font-size:15px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.3'+I+';letter-spacing:-.005em'+I+';margin:0'+I+';padding:0'+I+';overflow:hidden'+I+';text-overflow:ellipsis;display:-webkit-box'+I+';-webkit-line-clamp:2;-webkit-box-orient:vertical;border:none'+I+'}',
      p + ' .mc-qty-text{font-size:13px'+I+';color:var(--ds-text-muted,#666)'+I+';font-weight:500'+I+';padding:0'+I+';margin:0'+I+';line-height:1.3'+I+'}',
      p + ' .mc-price{display:block'+I+';text-align:right'+I+';font-size:18px'+I+';font-weight:800'+I+';color:var(--ds-text,#111)'+I+';letter-spacing:-.01em'+I+';line-height:1'+I+';padding:0'+I+';margin:6px 0 0'+I+'}',

      /* ─── Mengenrabatt: Strike-Through + Saved + Tier-Badge ── */
      p + ' .mc-price-wrap{display:flex'+I+';flex-direction:column'+I+';align-items:flex-end'+I+';gap:2px'+I+';margin:6px 0 0'+I+';padding:0'+I+'}',
      p + ' .mc-price-orig{display:block'+I+';text-align:right'+I+';font-size:13px'+I+';font-weight:500'+I+';color:var(--ds-text-dim,#999)'+I+';text-decoration:line-through'+I+';line-height:1'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-price-wrap .mc-price{margin:0'+I+';color:var(--ds-green,#0A7D56)'+I+'}',
      p + ' .mc-price-saved{display:inline-flex'+I+';align-items:center'+I+';font-size:11px'+I+';font-weight:600'+I+';color:var(--ds-green,#0A7D56)'+I+';background:rgba(45,212,160,.10)'+I+';border-radius:6px'+I+';padding:3px 7px'+I+';margin:4px 0 0'+I+';line-height:1.2'+I+';letter-spacing:.01em'+I+'}',
      p + ' .mc-tier-badge{display:flex'+I+';align-items:center'+I+';gap:8px'+I+';padding:8px 12px'+I+';margin:0 0 12px'+I+';background:linear-gradient(180deg,rgba(45,212,160,.10) 0%,rgba(45,212,160,.04) 100%)'+I+';border:1px solid rgba(45,212,160,.28)'+I+';border-radius:10px'+I+';font-size:12px'+I+';color:var(--ds-text,#111)'+I+';line-height:1.35'+I+'}',
      p + ' .mc-tier-ico{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:22px'+I+';height:22px'+I+';color:var(--ds-green,#0A7D56)'+I+';flex-shrink:0'+I+'}',
      p + ' .mc-tier-ico svg{width:14px'+I+';height:14px'+I+'}',
      p + ' .mc-tier-txt{flex:1'+I+';min-width:0'+I+';font-weight:500'+I+'}',
      p + ' .mc-tier-txt strong{font-weight:700'+I+';color:var(--ds-green,#0A7D56)'+I+'}',
      /* Footer-Aufschlüsselung (Listenpreis / Mengenrabatt) */
      p + ' .mc-total-detail{display:flex'+I+';flex-direction:column'+I+';gap:4px'+I+';padding:10px 12px'+I+';margin:0'+I+';background:var(--ds-surface-el,#fafafa)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.06))'+I+';border-radius:10px'+I+'}',
      p + ' .mc-total-row{display:flex'+I+';justify-content:space-between'+I+';align-items:baseline'+I+';gap:12px'+I+';font-size:13px'+I+';line-height:1.3'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-row span{padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-row-orig{color:var(--ds-text-muted,#666)'+I+'}',
      p + ' .mc-total-orig-val{text-decoration:line-through'+I+';font-weight:500'+I+'}',
      p + ' .mc-total-row-saved{color:var(--ds-green,#0A7D56)'+I+';font-weight:600'+I+'}',
      p + ' .mc-total-saved-val{font-weight:700'+I+'}',

      /* ─── Sekundärer Reset-Button (im Footer) ────────────── */
      p + ' .mc-reset{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:8px'+I+';width:100%'+I+';padding:11px 18px'+I+';background:transparent'+I+';color:var(--ds-text-muted,#666)'+I+';border:1px solid var(--ds-border,rgba(0,0,0,.12))'+I+';border-radius:10px'+I+';font-size:13px'+I+';font-weight:600'+I+';letter-spacing:.01em'+I+';cursor:pointer'+I+';font-family:inherit'+I+';transition:border-color .18s,color .18s,background .18s'+I+';box-shadow:none'+I+';margin:0'+I+'}',
      p + ' .mc-reset svg{width:15px'+I+';height:15px'+I+'}',
      p + ' .mc-reset:hover{border-color:var(--ds-text-muted,#666)'+I+';color:var(--ds-text,#111)'+I+';background:var(--ds-surface-hover,rgba(0,0,0,.03))'+I+'}',
      p + ' .mc-reset:active{background:var(--ds-surface-el,#f6f6f6)'+I+'}',

      /* ─── Empty-State ───────────────────────────────────── */
      p + ' .mc-empty{display:flex'+I+';flex-direction:column'+I+';align-items:center'+I+';justify-content:center'+I+';text-align:center'+I+';gap:14px'+I+';padding:60px 24px 40px'+I+';color:var(--ds-text-muted,#666)'+I+';min-height:320px'+I+';margin:0'+I+'}',
      p + ' .mc-empty-icon{width:72px'+I+';height:72px'+I+';border-radius:50%'+I+';background:var(--ds-surface-el,#f6f6f6)'+I+';display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';color:var(--ds-text-dim,#aaa)'+I+';border:1px dashed var(--ds-border-strong,rgba(0,0,0,.12))'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-empty-icon svg{width:32px'+I+';height:32px'+I+'}',
      p + ' .mc-empty-title{font-size:17px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';margin:4px 0 0'+I+';letter-spacing:-.005em'+I+';padding:0'+I+';border:none'+I+'}',
      p + ' .mc-empty-text{font-size:13px'+I+';line-height:1.55'+I+';color:var(--ds-text-muted,#666)'+I+';max-width:260px'+I+';margin:0'+I+';padding:0'+I+'}',
      p + ' .mc-empty-cta{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:6px'+I+';padding:11px 20px'+I+';background:transparent'+I+';border:1.5px solid var(--ds-border-strong,rgba(0,0,0,.16))'+I+';border-radius:10px'+I+';color:var(--ds-text,#111)'+I+';font-size:13px'+I+';font-weight:600'+I+';cursor:pointer'+I+';font-family:inherit'+I+';margin:8px 0 0'+I+';transition:border-color .2s,background .2s'+I+'}',
      p + ' .mc-empty-cta:hover{border-color:var(--ds-accent,#D6001C)'+I+';color:var(--ds-accent,#D6001C)'+I+';background:var(--ds-accent-soft,rgba(214,0,28,.04))'+I+'}',

      /* ─── Footer ────────────────────────────────────────── */
      p + ' .mc-foot{border:none'+I+';border-top:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';padding:20px 24px calc(20px + env(safe-area-inset-bottom,0px))'+I+';background:var(--ds-surface,#fff)'+I+';flex-shrink:0'+I+';display:flex'+I+';flex-direction:column'+I+';gap:14px'+I+';margin:0'+I+'}',
      p + ' .mc-total{display:flex'+I+';justify-content:space-between'+I+';align-items:baseline'+I+';gap:16px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl span{font-size:14px'+I+';font-weight:600'+I+';color:var(--ds-text,#111)'+I+';line-height:1.2'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-lbl small{font-size:11px'+I+';color:var(--ds-text-dim,#888)'+I+';font-weight:500'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-total-val{font-size:24px'+I+';font-weight:800'+I+';color:var(--ds-text,#111)'+I+';line-height:1'+I+';letter-spacing:-.02em'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-checkout{display:flex'+I+';align-items:center'+I+';justify-content:center'+I+';gap:10px'+I+';width:100%'+I+';padding:15px 24px'+I+';background:linear-gradient(180deg,#D6001C 0%,#A80016 100%)'+I+';color:#fff'+I+';border:none'+I+';border-radius:12px'+I+';font-size:16px'+I+';font-weight:700'+I+';letter-spacing:.01em'+I+';cursor:pointer'+I+';font-family:inherit'+I+';box-shadow:0 6px 16px rgba(214,0,28,.30),0 2px 4px rgba(214,0,28,.20),inset 0 -2px 0 rgba(0,0,0,.12)'+I+';transition:transform .15s,box-shadow .2s'+I+';position:relative'+I+';margin:0'+I+'}',
      p + ' .mc-checkout:hover{transform:translateY(-1px)'+I+';box-shadow:0 8px 24px rgba(214,0,28,.40),0 2px 6px rgba(214,0,28,.24),inset 0 -2px 0 rgba(0,0,0,.12)'+I+'}',
      p + ' .mc-checkout:active{transform:translateY(0)'+I+';box-shadow:0 4px 12px rgba(214,0,28,.28),inset 0 -1px 0 rgba(0,0,0,.12)'+I+'}',
      p + ' .mc-checkout svg{width:16px'+I+';height:16px'+I+'}',
      /* ─── Personalisierter Hero-Banner (gr\u00fcn = positives Signal) ── */
      p + ' .mc-hero-banner{display:flex'+I+';align-items:center'+I+';gap:12px'+I+';padding:14px 16px'+I+';background:rgba(45,212,160,.08)'+I+';border:1px solid rgba(45,212,160,.28)'+I+';border-radius:12px'+I+';margin:0'+I+'}',
      p + ' .mc-hero-icon{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:34px'+I+';height:34px'+I+';border-radius:10px'+I+';background:var(--ds-green,#2DD4A0)'+I+';color:#fff'+I+';flex-shrink:0'+I+'}',
      p + ' .mc-hero-icon svg{width:16px'+I+';height:16px'+I+';display:block'+I+'}',
      p + ' .mc-hero-text{display:flex'+I+';flex-direction:column'+I+';gap:2px'+I+';min-width:0'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-hero-eyebrow{font-size:11px'+I+';font-weight:700'+I+';letter-spacing:.06em'+I+';text-transform:uppercase'+I+';color:var(--ds-green,#2DD4A0)'+I+';line-height:1.2'+I+';margin:0'+I+'}',
      p + ' .mc-hero-detail{font-size:15px'+I+';font-weight:700'+I+';color:var(--ds-text,#111)'+I+';line-height:1.25'+I+';letter-spacing:-.005em'+I+';margin:0'+I+'}',

      /* ─── Produkt-USPs (eingebettet in die Item-Card, durch Separator getrennt) ─ */
      p + ' .mc-usp{list-style:none'+I+';padding:14px 0 0'+I+';margin:14px 0 0'+I+';background:transparent'+I+';border:none'+I+';border-top:1px solid var(--ds-border,rgba(0,0,0,.08))'+I+';border-radius:0'+I+';display:flex'+I+';flex-direction:column'+I+';gap:10px'+I+'}',
      p + ' .mc-usp-row{display:flex'+I+';align-items:flex-start'+I+';gap:10px'+I+';font-size:13px'+I+';color:var(--ds-text,#111)'+I+';font-weight:500'+I+';line-height:1.4'+I+';padding:0'+I+';margin:0'+I+'}',
      p + ' .mc-usp-ico{display:inline-flex'+I+';align-items:center'+I+';justify-content:center'+I+';width:18px'+I+';height:18px'+I+';border-radius:50%'+I+';background:var(--ds-green,#2DD4A0)'+I+';color:#fff'+I+';flex-shrink:0'+I+';margin-top:1px'+I+'}',
      p + ' .mc-usp-ico svg{width:11px'+I+';height:11px'+I+';display:block'+I+';stroke-width:3'+I+'}',
      p + ' .mc-usp-txt{flex:1'+I+';min-width:0'+I+'}',

      /* ─── Dev-Hint ──────────────────────────────────────── */
      p + ' .mc-dev-hint{display:block'+I+';padding:8px 12px'+I+';border:1px dashed var(--ds-border-strong,rgba(0,0,0,.14))'+I+';border-radius:8px'+I+';font-size:11px'+I+';color:var(--ds-text-dim,#888)'+I+';text-align:center'+I+';background:var(--ds-surface-el,#fafafa)'+I+';line-height:1.4'+I+';letter-spacing:.01em'+I+';margin:0'+I+'}',

      /* ─── Mobile ────────────────────────────────────────── */
      '@media (max-width:520px){',
      '  ' + p + ' .mc-panel{width:100%'+I+';max-width:100%'+I+';border-left:none'+I+'}',
      '  ' + p + ' .mc-head{padding:18px 20px 14px'+I+'}',
      '  ' + p + ' .mc-body{padding:16px 16px 8px'+I+'}',
      '  ' + p + ' .mc-item{padding:14px'+I+';grid-template-columns:72px 1fr'+I+';gap:12px'+I+'}',
      '  ' + p + ' .mc-thumb{width:72px'+I+';height:72px'+I+'}',
      '  ' + p + ' .mc-foot{padding:18px 20px calc(18px + env(safe-area-inset-bottom,0px))'+I+'}',
      '  ' + p + ' .mc-total-val{font-size:22px'+I+'}',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(st);
  }

  /* ── Inline-Icons (stroke = currentColor) ─────────────────── */
  var ICO = {
    close:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    cart:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    arrow:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    refresh:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>',
    check:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    verified: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
    tag:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
  };

  /* ── DOM ──────────────────────────────────────────────────── */
  function buildPanel() {
    var el = document.createElement('div');
    el.id = PANEL_ID;
    el.innerHTML =
      '<div class="mc-backdrop" data-mc-close></div>' +
      '<aside class="mc-panel" role="dialog" aria-modal="true" aria-label="Warenkorb">' +
        '<header class="mc-head">' +
          '<div class="mc-head-title">' +
            '<h3>Ihr Warenkorb</h3>' +
            '<div class="mc-head-sub" id="mc-head-sub">&nbsp;</div>' +
          '</div>' +
          '<button class="mc-close" data-mc-close aria-label="Warenkorb schlie\u00dfen" title="Schlie\u00dfen">' + ICO.close + '</button>' +
        '</header>' +
        '<div class="mc-body" id="mc-body"></div>' +
        '<footer class="mc-foot" id="mc-foot"></footer>' +
      '</aside>';

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-mc-close]')) { close(); return; }
      if (e.target.closest('[data-mc-reset]'))  { handleReset(); return; }
    });

    /* ESC to close */
    document.addEventListener('keydown', function (e) {
      if (_open && e.key === 'Escape') close();
    });

    /* Panel innerhalb #isodash anhängen → erbt CSS-Variablen + Theme. */
    var host = document.getElementById('isodash') || document.body;
    host.appendChild(el);
    return el;
  }

  function renderCart(cart) {
    var body = document.getElementById('mc-body');
    var foot = document.getElementById('mc-foot');
    var sub  = document.getElementById('mc-head-sub');
    if (!body || !foot) return;

    var isDev = !!(cart && cart._demo);
    var items = (cart && cart.items) || [];
    var totalQty = items.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);

    /* Header-Subline: "3 Artikel · 24 Flaschen" oder "Leer" */
    if (sub) {
      if (!items.length) {
        sub.textContent = 'Keine Artikel';
      } else {
        var artLbl = items.length === 1 ? '1 Artikel' : items.length + ' Artikel';
        var flLbl  = totalQty === 1 ? '1 Flasche' : totalQty + ' Flaschen';
        sub.textContent = artLbl + ' \u00b7 ' + flLbl;
      }
    }

    /* Empty-State */
    if (!items.length) {
      body.innerHTML =
        '<div class="mc-empty">' +
          '<div class="mc-empty-icon">' + ICO.cart + '</div>' +
          '<div class="mc-empty-title">Ihr Warenkorb ist leer</div>' +
          '<p class="mc-empty-text">Sobald Ihre Analyse abgeschlossen ist, wird das Sanierungspaket automatisch hier angezeigt.</p>' +
          '<button class="mc-empty-cta" data-mc-close>Warenkorb schlie\u00dfen</button>' +
          (isDev ? '<div class="mc-dev-hint" style="margin-top:16px">Dev-Modus: keine Analyse geladen</div>' : '') +
        '</div>';
      foot.innerHTML = '';
      return;
    }

    /* Personalisierter Banner über dem Item (wenn Wand-Daten vorhanden) */
    var blurb = getWallBlurb();
    var bannerH = blurb
      ? '<div class="mc-hero-banner" role="note">' +
          '<div class="mc-hero-icon">' + ICO.verified + '</div>' +
          '<div class="mc-hero-text">' +
            '<div class="mc-hero-eyebrow">Exakt berechnet f\u00fcr Ihre Wand</div>' +
            '<div class="mc-hero-detail">' + blurb + '</div>' +
          '</div>' +
        '</div>'
      : '';

    /* Produkt-Stichpunkte (USPs) — eingebettet in jede Item-Card */
    /* "Exakt berechnet f\u00fcr Ihre Wand" steht bereits im Hero-Banner oben \u2192 hier raus. */
    var uspList = [
      'Einmalige Anwendung \u2013 kein Nachbehandeln',
      'Geeignet f\u00fcr Wohn- &amp; Schlafr\u00e4ume, Keller \u2013 innen oder au\u00dfen',
      'Flascheninhalt: 500\u202fml \u2013 inkl. Injektionsaufsatz'
    ];
    var uspInner = '<ul class="mc-usp">' +
      uspList.map(function (t) {
        return '<li class="mc-usp-row"><span class="mc-usp-ico">' + ICO.check + '</span><span class="mc-usp-txt">' + t + '</span></li>';
      }).join('') +
    '</ul>';

    /* Items (jedes Item enthält Ware + USPs in einer gemeinsamen Umrandung) */
    var itemsH = '';
    items.forEach(function (item, idx) {
      var line     = idx + 1;
      var thumb    = item.image || item.featured_image || '';
      var name     = item.product_title || item.title || 'Artikel';
      /* v229.4: Isofin-Line bekommt dynamischen Titel aus IsoWiz-Analyse */
      var _dynIso  = isIsofinLine(item) ? getIsofinDynamicTitle() : null;
      if (_dynIso && _dynIso.title) name = _dynIso.title;
      var disc     = getItemDiscount(item);
      var qty      = disc.qty;
      var linePrc  = disc.finalPrc;
      var origUnit  = qty > 0 ? (disc.origPrc  / qty) : 0;
      var finalUnit = qty > 0 ? (disc.finalPrc / qty) : 0;
      var priceBlock = disc.hasDiscount
        ? '<div class="mc-price-wrap">' +
            '<span class="mc-price-orig">' + formatEuro(disc.origPrc) + '</span>' +
            '<div class="mc-price">' + formatEuro(linePrc) + '</div>' +
            '<div class="mc-price-saved">Sie sparen ' + formatEuro(disc.saved) + '</div>' +
          '</div>'
        : '<div class="mc-price">' + formatEuro(linePrc) + '</div>';
      /* Mengenrabatt-Badge oberhalb der Item-Card, wenn Staffel aktiv */
      var tierBadge = disc.hasDiscount
        ? '<div class="mc-tier-badge">' +
            '<span class="mc-tier-ico">' + ICO.tag + '</span>' +
            '<span class="mc-tier-txt"><strong>Mengenrabatt aktiv</strong> \u00b7 ' +
              formatEuro(finalUnit) + ' / Flasche statt ' + formatEuro(origUnit) +
            '</span>' +
          '</div>'
        : '';
      itemsH += '<div class="mc-item" data-mc-line="' + line + '">' +
        tierBadge +
        '<div class="mc-item-main">' +
          (thumb
            ? '<img src="' + thumb + '" alt="" class="mc-thumb" loading="lazy">'
            : '<div class="mc-thumb"></div>') +
          '<div class="mc-info">' +
            '<h4 class="mc-name">' + name + '</h4>' +
            '<div class="mc-qty-text">' + (_dynIso ? ('Enth\u00e4lt ' + qty + ' Flaschen \u00e0 500\u202fml') : (qty + '\u00d7\u00a0Flaschen')) + '</div>' +
            priceBlock +
          '</div>' +
        '</div>' +
        uspInner +
      '</div>';
    });

    body.innerHTML = bannerH + itemsH;

    /* Footer \u2014 mit Mengenrabatt-Aufschl\u00fcsselung */
    var totals = getCartTotals(cart);
    var totalRow = totals.hasDiscount
      ? '<div class="mc-total-detail">' +
          '<div class="mc-total-row mc-total-row-orig">' +
            '<span>Listenpreis</span>' +
            '<span class="mc-total-orig-val">' + formatEuro(totals.original) + '</span>' +
          '</div>' +
          '<div class="mc-total-row mc-total-row-saved">' +
            '<span>Mengenrabatt</span>' +
            '<span class="mc-total-saved-val">\u2212' + formatEuro(totals.saved) + '</span>' +
          '</div>' +
        '</div>'
      : '';
    foot.innerHTML =
      totalRow +
      '<div class="mc-total">' +
        '<div class="mc-total-lbl">' +
          '<span>Zwischensumme</span>' +
          '<small>inkl. MwSt., zzgl. Versand</small>' +
        '</div>' +
        '<div class="mc-total-val">' + formatEuro(totals.final) + '</div>' +
      '</div>' +
      '<button class="mc-checkout" data-mc-checkout>Zum Checkout ' + ICO.arrow + '</button>' +
      '<button class="mc-reset" data-mc-reset>' + ICO.refresh + 'Sanierung neu berechnen</button>' +
      (isDev ? '<div class="mc-dev-hint">Dev-Modus: lokaler Mock \u2014 Shopify-Cart ist nicht erreichbar</div>' : '');

    var coBtn = foot.querySelector('[data-mc-checkout]');
    if (coBtn) {
      coBtn.addEventListener('click', function () {
        if (isDev) {
          alert('Dev-Modus: Checkout w\u00fcrde jetzt zu /checkout navigieren.');
          return;
        }
        window.location.href = '/checkout';
      });
    }
  }

  function refreshTopbar() {
    /* Force-refresh des Cart-Caches in der Shell — sonst greift dort der
       1.5s-Debounce und die Topbar zeigt kurz veraltete Werte. Direkt nach
       Mini-Cart-Mutationen (remove, add, …) wollen wir sofortige Konsistenz
       zwischen Cart-Sidebar und Topbar-Anzeige. */
    if (w.IsoDash && typeof w.IsoDash.refreshCartCache === 'function') {
      try { w.IsoDash.refreshCartCache(); } catch (_) {}
    } else if (w.IsoDash && typeof w.IsoDash.renderTopbarData === 'function') {
      try { w.IsoDash.renderTopbarData(); } catch (_) {}
    }
  }

  function handleReset() {
    /* Cart schließen und den zentralen Reset-Flow (Confirm-Modal + Storage-Reset + Reload)
       aus der Shell auslösen. */
    close();
    if (w.ID && typeof w.ID.resetAll === 'function') {
      /* Im Dashboard / auf Wizard-Seiten — Shell hat schon Modal + komplette Logik */
      setTimeout(function () { try { w.ID.resetAll(); } catch (_) {} }, 280);
      return;
    }
    /* v201: Standalone-Reset für alle anderen Seiten (Startseite, Produktseite, etc.) —
       Shell ist dort nicht geladen, daher inline:
       1. Confirm-Dialog, 2. Calculation-Storage löschen, 3. Shopify-Cart leeren,
       4. Navigation zur Kalkulator-Seite. */
    setTimeout(function () {
      if (!confirm('Möchten Sie die Sanierung neu berechnen?\n\nAlle aktuellen Eingaben und der Warenkorb werden zurückgesetzt.')) return;
      var keys = ['isodash_project_v8','isofinHeroState','isofinAnalysis','__ISOWIZ_RESUME_ANALYSIS__','__ISOWIZ_analysis','fa_state_v2','isodash_moisture_check_completed','isodash_flow_phase','isodash_entry_mode','isodash_capillary_fit','isodash_capillary_confidence','isodash_capillary_check','isodash_masonry_type','isodash_moisture_type','isodash_analysis_source','isodash_nav_unlock_shown','isodash_a2c_done','isodash_transition_shown','__ISOWIZ_state__','__ISOWIZ_share_state__','isodash-wiz:analysis','isodash-wiz:calcState','isofinCalcState'];
      keys.forEach(function (k) {
        try { localStorage.removeItem(k); } catch (_) {}
        try { sessionStorage.removeItem(k); } catch (_) {}
      });
      // v228.4: Wildcard-Cleanup für Wizard v27.7.13 — alle __ISOWIZ_* prefixed Keys löschen
      // (HERO_SEED, ANALYSIS, RESUME_STEP, MISMATCH_*, etc.) — vorherige Hardcode-Liste war
      // unvollständig, Wizard hat resumed weil Namespace-Keys liegen blieben.
      try {
        for (var i = localStorage.length - 1; i >= 0; i--) {
          var lk = localStorage.key(i);
          if (lk && lk.indexOf('__ISOWIZ') === 0) localStorage.removeItem(lk);
        }
      } catch (_) {}
      try {
        for (var j = sessionStorage.length - 1; j >= 0; j--) {
          var sk = sessionStorage.key(j);
          if (sk && sk.indexOf('__ISOWIZ') === 0) sessionStorage.removeItem(sk);
        }
      } catch (_) {}
      // IsoWiz Storage API direkt nutzen falls verfügbar (v27.7.13)
      try { if (window.IsoWiz && window.IsoWiz.Storage && typeof window.IsoWiz.Storage.resetAll === 'function') window.IsoWiz.Storage.resetAll(); } catch (_) {}
      var done = false;
      function _go() {
        if (done) return;
        done = true;
        try { window.location.href = '/pages/kalkulator'; } catch (_) { window.location.reload(); }
      }
      try {
        fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
          .then(_go, _go);
        setTimeout(_go, 1500);
      } catch (_) { _go(); }
    }, 280);
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      _cartData = cart;
      renderCart(cart);
      refreshTopbar();
      return cart;
    });
  }

  /* ── Public API ───────────────────────────────────────────── */
  function open() {
    /* v148: Defensiv — falls open() aufgerufen wird bevor init() lief
       (z.B. via header.liquid Event-Delegation auf einer Page wo es
       kein Dashboard gibt), CSS hier nachholen. */
    if (!document.getElementById(CSS_ID)) injectCSS();
    if (!_panel) _panel = buildPanel();
    _panel.classList.add('mc-open');
    _open = true;
    try { document.body.style.overflow = 'hidden'; } catch (_) {}
    refresh();
  }

  function close() {
    if (_panel) _panel.classList.remove('mc-open');
    _open = false;
    try { document.body.style.overflow = ''; } catch (_) {}
  }

  /* ── Topbar-Binding (Klick auf #tb-sys-wrap und #tb-prod-img) ── */
  function wireTopbar() {
    var tries = 0;
    var tick = function () {
      var sys = document.getElementById('tb-sys-wrap');
      var img = document.getElementById('tb-prod-img');
      var wired = 0;
      [sys, img].forEach(function (el) {
        if (!el || el.dataset.mcWired) return;
        el.style.cursor = 'pointer';
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', 'Warenkorb \u00f6ffnen');
        el.addEventListener('click', function (e) { e.preventDefault(); open(); });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
        });
        el.dataset.mcWired = '1';
        wired++;
      });
      tries++;
      if (!(sys && img) && tries < 30) setTimeout(tick, 250);
    };
    tick();
  }

  function init() {
    injectCSS();
    wireTopbar();
  }

  w.IsoDashMiniCart = { open: open, close: close, refresh: refresh, init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
